module.exports = __webpack_public_path__ + "img/2.5fc1fc8b.png";